module.exports = "/_next/static/images/phi-696c321ddf798f4fe708151f0c4144cd.jpg.webp";